import { dataSourceItem } from "../../redux/models/reduxModels";

export class DatasourceFieldHelper {
  static checkDatasourceAllowed(sites: string[], libraries: string[], datasource: dataSourceItem) {
    let siteAllowed: boolean = true;
    let libraryAllowed: boolean = true;

    if (datasource?.site
      && Array.isArray(sites) && sites.length > 0
      && !datasource.site.split(";").some(site => sites.some(s => site?.trim().toUpperCase() === s.trim().toUpperCase()))) {
      siteAllowed = false;
    }

    if (siteAllowed
      && datasource?.library
      && Array.isArray(libraries) && libraries.length > 0
      && !datasource.library.split(";").some(library => libraries.some(l => library?.trim().toUpperCase() === l.trim().toUpperCase()))) {
      libraryAllowed = false;
    }

    if (siteAllowed && libraryAllowed) {
      if (datasource?.siteBlacklist
        && Array.isArray(sites) && sites.length > 0
        && datasource.siteBlacklist.split(";").some(site => sites.some(s => site?.trim().toUpperCase() === s.trim().toUpperCase()))) {
        siteAllowed = false;
      }

      if (siteAllowed
        && datasource?.libraryBlacklist
        && Array.isArray(libraries) && libraries.length > 0
        && datasource.libraryBlacklist.split(";").some(library => libraries.some(l => library?.trim().toUpperCase() === l.trim().toUpperCase()))) {
        libraryAllowed = false;
      }
    }

    return (siteAllowed && libraryAllowed);
  }

  static getDatasourceFields(datasources: dataSourceItem[], sites: string[], libraries: string[]) {
    return datasources
      .filter(item => this.checkDatasourceAllowed(sites, libraries, item))
      .map(item => item.boundFields)
      .reduce((acc, current) => acc.concat(current), []);
  }
}